// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const alcremie: PokeData = {
  "id": 869,
  "name": "alcremie",
  "height": 3,
  "weight": 5,
  "base_experience": 173,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "recover",
    "acid-armor",
    "sweet-kiss",
    "charm",
    "attract",
    "sweet-scent",
    "aromatherapy",
    "entrainment",
    "draining-kiss",
    "misty-terrain",
    "aromatic-mist",
    "dazzling-gleam",
    "decorate"
  ],
  "moves": [
    "tackle",
    "sweet-kiss",
    "aromatherapy",
    "misty-terrain",
    "dazzling-gleam",
    "moonblast",
    "guardian-bond",
    "hyper-voice",
    "starfall",
    "moonlight",
    "spirit-break",
    "mist-terrain",
    "play-rough"
  ],
  "evolution_chain": {
    "id": 452,
    "item": null,
    "species": [
      {
        "name": "milcery",
        "order": 868,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "alcremie",
        "order": 869,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 868,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.SPIN
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 128,
    "speed": 100,
    "ability_power": 172
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
